export default __webpack_public_path__ + "img/main.purl.adff5583.png";